module.exports = __webpack_public_path__ + "static/media/6.3d032181.jpeg";